import UpdateCertificateOfOriginFee from "../UpdateCertificateOfOriginFee/UpdateCertificateOfOriginFee";

const ViewCertificateOfOriginFee = (props) => {
  return <UpdateCertificateOfOriginFee {...props} viewMode={true} />;
};

export default ViewCertificateOfOriginFee;
